import React from 'react'
import {
  Center,
  Box,
  Button,
  Heading,
  HStack,
  Image,
  Link,
  Text,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react'
import { useTranslations } from 'next-intl'

import { CALENDLY_LINK } from '@/constants'

export const MiningVsBuying = () => {
  const t = useTranslations()
  return (
    <Box textAlign="center">
      <Heading
        as="h2"
        variant="spaceGrotesk"
        fontSize="40px"
        fontWeight={300}
        mb={2}
      >
        {t.rich('minebitcoin.comparison.title', {
          strong: (children) => (
            <Text as="span" variant="brandGradient">
              {children}
            </Text>
          ),
        })}
      </Heading>
      <Heading
        as="h4"
        fontSize="24px"
        fontWeight={300}
        mb="9"
        color={useColorModeValue('blackAlpha.800', 'whiteAlpha.800')}
      >
        {t.rich('minebitcoin.comparison.subtitle')}
      </Heading>
      <Box
        px={{ base: 4, md: 8 }}
        py={8}
        border="1px"
        borderColor={useColorModeValue('blackAlpha.500', 'whiteAlpha.500')}
        rounded="lg"
        mb={9}
      >
        <VStack spacing={2} fontWeight={500} lineHeight={1.375}>
          <HStack w="100%" spacing={2} display={{ base: 'none', md: 'flex' }}>
            <Box w="100%" />
            <Box w="100%" position="relative" overflow="hidden">
              <Image
                mx="auto"
                src="/img/comparison1.png"
                alt={t('minebitcoin.comparison.mining')}
                bg="black"
              ></Image>
              <Box
                position="absolute"
                w="100%"
                bottom="-10px"
                height="87px"
                background="linear-gradient(180deg, #FFF 0%, #000 100%);"
                mixBlendMode="multiply"
              ></Box>
            </Box>
            <Box w="100%" position="relative" overflow="hidden">
              <Image
                mx="auto"
                src="/img/comparison2.png"
                alt={t('minebitcoin.comparison.buying')}
              ></Image>
              <Box
                position="absolute"
                w="100%"
                bottom="-10px"
                height="87px"
                background="linear-gradient(180deg, #FFF 0%, #000 100%);"
                mixBlendMode="multiply"
              ></Box>
            </Box>
          </HStack>
          <HStack
            w="100%"
            spacing={2}
            fontSize="24px"
            fontWeight={700}
            textAlign="center"
          >
            <Box w="100%" />
            <Box w="100%">{t('minebitcoin.comparison.mining')}</Box>
            <Box w="100%">{t('minebitcoin.comparison.buying')}</Box>
          </HStack>
          <HStack w="100%" spacing={2}>
            <Text w="100%" textAlign="left">
              {t('minebitcoin.comparison.listitem1')}
            </Text>
            <Text w="100%" fontSize="24px" variant="brandGradient">
              ✓
            </Text>
            <Text w="100%" fontSize="32px" color="red.500">
              ×
            </Text>
          </HStack>
          <HStack w="100%" spacing={2}>
            <Text w="100%" textAlign="left">
              {t('minebitcoin.comparison.listitem2')}
            </Text>
            <Text w="100%" fontSize="24px" variant="brandGradient">
              ✓
            </Text>
            <Text w="100%" fontSize="32px" color="red.500">
              ×
            </Text>
          </HStack>
          <HStack w="100%" spacing={2}>
            <Text w="100%" textAlign="left">
              {t('minebitcoin.comparison.listitem3')}
            </Text>
            <Text w="100%" fontSize="24px" variant="brandGradient">
              ✓
            </Text>
            <Text w="100%" fontSize="32px" color="red.500">
              ×
            </Text>
          </HStack>
          <HStack w="100%" spacing={2}>
            <Text w="100%" textAlign="left">
              {t('minebitcoin.comparison.listitem4')}
            </Text>
            <Text w="100%" fontSize="24px" variant="brandGradient">
              ✓
            </Text>
            <Text w="100%" fontSize="32px" color="red.500">
              ×
            </Text>
          </HStack>
        </VStack>
      </Box>
      <Center>
        <Button
          as={Link}
          href={CALENDLY_LINK}
          isExternal
          variant="outlineGradient"
          minW={{ base: 'full', md: '372px' }}
        >
          <Text>{t('buttons.book-call')}&nbsp;→</Text>
        </Button>
      </Center>
    </Box>
  )
}
